// extracted by mini-css-extract-plugin
export default {"Header__Section":"Header_Header__Section__7IURR","Main__Title":"Header_Main__Title__-hCqu","Description":"Header_Description__LHUFu","Header__Image":"Header_Header__Image__yCOh7"};